import { EntityActionFactory, EntityOp } from '@ngrx/data';

import { TipoEquipamientoProcesamiento } from './tipos-equipamiento-procesamiento.model';

const entityActionFactory = new EntityActionFactory();

export const entityTiposEquipamientoProcesamientoLoadRequest =
  entityActionFactory.create<TipoEquipamientoProcesamiento>(
    'TipoEquipamientoProcesamiento',
    EntityOp.QUERY_ALL
  );
